import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { VehicleSummaryStyled } from '../VehicleSummaryStyled';
import { rem } from 'polished';

export const VehicleSummaryStyledOV = styled(VehicleSummaryStyled)`
    .summary-price-container {
        padding-top: ${rem('15.5px')};
        padding-bottom: ${rem('15.5px')};
        border-top: 1px solid ${({ theme }) => theme.colors.grey18};
        border-bottom: 1px solid ${({ theme }) => theme.colors.grey18};
        width: 100%;
        .content {
            .header {
                .catalog-price-title {
                    font-size: ${({ theme }) => theme.fontSizes.textBase};
                    border-top: unset;
                    border-bottom: 1px solid ${({ theme }) => theme.colors.grey18};
                }
            }

            .body {
                .body-wrapper {
                    .price {
                        font-size: ${rem(20)};
                    }

                    .infoIcon {
                        svg {
                            width: ${rem(20)};
                            height: ${rem(22)};
                            margin-top: ${rem(-4)};

                            path {
                                fill: ${({ theme }) => theme.colors.black};
                            }
                        }
                    }

                    .footer {
                        font-size: ${rem(10)};
                    }

                    .prefix {
                        margin-top: ${rem(3)};
                    }
                }
            }
        }
    }

    .benefits-wrapper {
        background: white;
        margin-top: ${rem(25)};
    }

    .benefits {
        margin: ${rem(20)} ${rem(10)} ${rem(10)} ${rem(10)};

        .bullet-points.allow-bullet-points {
            padding: 0 ${rem(16)};
        }

        svg {
            height: ${rem(22)};
            g {
                circle {
                    fill: ${({ theme }) => theme.colors.black};
                }

                path {
                    fill: ${({ theme }) => theme.colors.white} !important;
                }
            }
        }
    }

    span.title {
        font-size: ${rem('16px')};
        padding: ${rem('31px')} 0 ${rem('31px')} 0;

        @media (max-width: ${breakpoints.sm}px) {
            display: none;
        }
    }

    .delivery-container {
        .link {
            .txt {
                &:hover {
                    color: ${({ theme }) => theme.colors.black};

                    span {
                        border-color: ${({ theme }) => theme.colors.black};
                    }
                }
            }
        }
    }
`;
